/* eslint-disable react/prop-types */
import React from 'react';
import PostCard from './PostCard';
import NoPostsCard from './NoPostsCard';
import UpgradeCard from './UpgradeCard';

const PostList = ({ posts, showUpgradeCTA, redirectUri, onPostClick, onCancelPost }) => {
  return (
    <div className='mb-8'>
      <h2 className='text-lg font-bold mb-4' style={{ color: 'var(--text-primary)' }}>
        Upcoming Posts
      </h2>
      <div
        className={`grid grid-cols-1 ${posts.length ? 'md:grid-cols-2 lg:grid-cols-4 ' : ''}gap-6`}
      >
        {posts.length
          ? posts?.map((post) => (
              <PostCard
                key={post.id}
                post={post}
                onClick={() => onPostClick(post)}
                onCancel={onCancelPost}
              />
            ))
          : null}

        {showUpgradeCTA ? (
          <UpgradeCard onUpgrade={() => (window.location.href = redirectUri)} />
        ) : !posts.length ? (
          <NoPostsCard
            shouldUpgrade={showUpgradeCTA}
            onUpgrade={() => (window.location.href = redirectUri)}
          />
        ) : null}
      </div>
    </div>
  );
};

export default PostList;
